module.exports = new __parcel__URL__("add-on-v2.4ce82c76.svg").toString();